import React, { useState } from 'react'
import classnames from 'classnames'

import ContentBlockLibrary from '../ContentBlockLibrary'
import ContentBlockList from '../ContentBlockList'

import * as S from './styled'

const VIEW_LIBRARY = 1
const VIEW_LIST = 2

const ContentBlockAdd = props => {
    const [view, setView] = useState(VIEW_LIST)

    let content = null

    switch (view) {
        case VIEW_LIST:
            content = <ContentBlockList {...props} />
            break
        case VIEW_LIBRARY:
        default:
            content = <ContentBlockLibrary {...props} />
    }

    return (
        <S.Wrapper>
            <S.Tabs className="btn-group ">
                <S.Button
                    className={classnames('btn btn-secondary !rounded-none', {
                        active: view === VIEW_LIST,
                    })}
                    onClick={() => setView(VIEW_LIST)}
                >
                    Blocks
                </S.Button>
                <S.Button
                    className={classnames('btn btn-secondary !rounded-none', {
                        active: view === VIEW_LIBRARY,
                    })}
                    onClick={() => setView(VIEW_LIBRARY)}
                >
                    Templates
                </S.Button>
            </S.Tabs>
            <S.List>{content}</S.List>
        </S.Wrapper>
    )
}

export default ContentBlockAdd
